import { SEND_REVIEW_LINK } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

interface Payload {
    clinicid: string;
    patientid: string;
}

interface Res {
    success: boolean;
    error: {
        message: string;
    };
}

export default function sendGoogleReviewLink(aid: string): Promise<Res> {
    return fetchWithRefresh(SEND_REVIEW_LINK(aid), {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    }).then((res) => {
        return res.json();
    });
}
